import { QuizResult, UserAnswer } from '../types';

export const calculateScore = (result: QuizResult): number => {
    const correctAnswers = Array.from(result.answers.values()).filter((a: UserAnswer) => a.isCorrect).length;
    const totalQuestions = result.questions.length;
    const minScore = 100;
    const maxScore = 1000;

    const score = totalQuestions > 0
        ? Math.round(minScore + ((correctAnswers / totalQuestions) * (maxScore - minScore)))
        : minScore;

    return score;
};

export const getPassingScore = (): number => 720;
